export enum BoundaryEditSubmitModalAction {
  AddToExistingTerritory = 'AddToExistingTerritory',
  RemoveBoundariesFromTerritory = 'RemoveBoundariesFromTerritory',
  ReassignTerritory = 'ReassignTerritory',
}
